import React, { useState } from "react";
import styles from "./AdminLogin.module.css";
import { useNavigate } from "react-router-dom";
import { apiService } from "../../services/api";
// import { t } from "../../utils/localization";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError("");
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const response = await apiService.login(
        formData.email,
        formData.password
      );
      localStorage.setItem("token", response.token);
      localStorage.setItem("user", JSON.stringify(response.user));
      navigate("/admin");
    } catch (err: any) {
      console.error("Login error:", err);
      
      // Check if we got HTML response instead of JSON (backend not running or wrong URL)
      const responseText = err.response?.data;
      if (typeof responseText === 'string' && responseText.trim().startsWith('<!')) {
        setError("Бэкенд не запущен или недоступен. Убедитесь, что сервер запущен на порту 3001 и переменная REACT_APP_API_URL настроена правильно.");
      } else if (err.code === 'ECONNREFUSED' || err.message?.includes('Network Error')) {
        setError("Не удалось подключиться к серверу. Убедитесь, что бэкенд запущен на порту 3001.");
      } else {
        // Обработка ошибок валидации
        if (err.response?.status === 400 && err.response?.data?.errors) {
          const validationErrors = err.response.data.errors;
          const errorMessages = validationErrors.map((err: any) => err.msg).join(", ");
          setError(errorMessages);
        } else {
          setError(err.response?.data?.message || "Неверный логин или пароль!");
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginCard}>
        <h1 className={styles.loginTitle}>Вход в панель управления</h1>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="email">
              Электронная почта
            </label>
            <input
              className={styles.input}
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={isLoading}
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="password">
              Пароль
            </label>
            <input
              className={styles.input}
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              disabled={isLoading}
            />
          </div>

          <button className={styles.button} type="submit" disabled={isLoading}>
            {isLoading && <span className={styles.loadingSpinner} />}
            {isLoading ? "Вход..." : "Войти"}
          </button>

          {error && <div className={styles.errorMessage}>{error}</div>}
        </form>
      </div>
    </div>
  );
}
